import * as neway from 'api/neway';
import { USER_UPDATED, USER_AFFILIATION_UPDATED, USER_AFFILIATION_REMOVED, USER_PREFERENCES_UPDATED } from '../constants/users';

export function getUser() {
    return async dispatch => {
        const user = await neway.getUser();
        dispatch({ type: USER_UPDATED, payload: { user } });
        return user;
    };
}

export function updateUser(updatedUser) {
    return async dispatch => {
        const user = await neway.updateUser(updatedUser);
        dispatch({ type: USER_UPDATED, payload: { user } });
        return user;
    };
}

export function updateUserData(type, data) {
    return async dispatch => {
        const user = await neway.updateUserData(type, data);
        await dispatch({ type: USER_UPDATED, payload: { user } });
        return user;
    };
}

// Affiliations
export function updateUserAffiliation(affiliationId) {
    return async dispatch => {
        const user = await neway.updateUserAffiliation(affiliationId);
        dispatch({ type: USER_AFFILIATION_UPDATED, payload: { user } });
    };
}

export function updateUserAffiliationData(affiliationId, data) {
    return async dispatch => {
        const user = await neway.updateUserAffiliation(affiliationId, data);
        dispatch({ type: USER_AFFILIATION_UPDATED, payload: { user } });
    };
}

export function removeUserAffiliation(affiliationId) {
    return async dispatch => {
        const user = await neway.removeUserAffiliation(affiliationId);
        dispatch({ type: USER_AFFILIATION_REMOVED, payload: { user } });
    };
}

// Preferences
export function updateUserPreferences(preferenceSection, value) {
    return async dispatch => {
        const user = await neway.updateUserPreferences(preferenceSection, value);
        dispatch({ type: USER_PREFERENCES_UPDATED, payload: { user } });
    };
}
